export default function checkEnvironment() {
  const isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';
  return {
    isDev,
    isProd: !isDev,
  };
}
